import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BACKBONE_URL, PAGE_RESULT_SIZE } from '../../shared/constants';
import { AzureEndpoint } from '../../shared/models/azure-endpoints.model';
import { UpdateActiveStatusRequest } from '../../shared/models/azure-namespaces.model';


@Injectable({
  providedIn: 'root'
})
export class AzureEndpointsService {

  constructor(private httpClient: HttpClient) { }

  public getRecordCounts(filter: string = null) {
    let address = `${BACKBONE_URL}AzureEndpoints/count`;

    if (filter)
      address = `${address}?filter=${filter}`;

    return this.httpClient.get(address);
  }

  public getEndpointById(id: number) {
    let address = `${BACKBONE_URL}AzureEndpoints/${id}`;

    return this.httpClient.get(address);
  }

  public getEndpoints(pageNo: number, filter: string = null) {
    let address = BACKBONE_URL + `AzureEndpoints?page=${pageNo}&result=${PAGE_RESULT_SIZE}`;

    if (filter)
      address = `${address}&filter=${filter}`;

    return this.httpClient.get(address);
  }

  public createEndpoint(model: AzureEndpoint) {
    let address = `${BACKBONE_URL}AzureEndpoints`;
    return this.httpClient.post(address, model);
  }

  public updateEndpoint(model: AzureEndpoint) {
    let address = `${BACKBONE_URL}AzureEndpoints/${model.Id}`;
    return this.httpClient.put(address, model);
  }

  public deleteEndpoint(id: number) {
    let address = `${BACKBONE_URL}AzureEndpoints/${id}`;
    return this.httpClient.delete(address);
  }

  public updateActiveStatus(model: UpdateActiveStatusRequest) {
    const address = `${BACKBONE_URL}AzureEndpoints/update-active-status/${model.id}`;
    return this.httpClient.put(address, model);
  }
}
